<template>
  <div
    class="beschreibung-tooltip p-2 mt-4 rounded border d-flex justify-content-center"
    v-bind:style="{ backgroundColor: color }"
  >
    <span v-html="this.params.value"></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      color: null,
    };
  },
  beforeMount() {
    this.color = this.params.color || 'white';
  },
};
</script>
<style scoped>
.beschreibung-tooltip {
  color: #333;
  max-width: 750px;
  background-color: var(--surface);
}

.beschreibung-tooltip >>> table {
  width: 100%;
  border-collapse: collapse;
}

.beschreibung-tooltip >>> td {
  border: 1px solid #ddd;
  padding: 6px 8px;
  vertical-align: top;
}

.beschreibung-tooltip >>> img {
  max-width: 100%;
  height: auto;
}
</style>
